import BaseVisualizationService from '@configuratorware/configurator-frontendgui/App/Services/VisualizationService';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { createAdapterConfig } from 'redhotmagma-visualization/visualizationAdapterCreator';
import Visualization from '../Visualization/Visualization';

class VisualizationService extends BaseVisualizationService {
  adapterConfig = createAdapterConfig(
    { host: getConf('network.host') },
    {
      '3dVariant': {
        adapterClass: Visualization,
      },
      '3dScene': {
        adapterClass: Visualization,
      },
    }
  );

  setView(view) {
    const component = this.getComponent();
    component && component.jumpToView(view);
  }
}

export default VisualizationService;
